import { ref } from 'vue';

const showMenu = ref(false);
const showBottomNavbar = ref(false);

export { showMenu, showBottomNavbar }
